import React from 'react';
import bowser from 'yola-bowser';
import classnames from 'classnames';

const getItemSource = (source) => {
  if (typeof source === 'string') {
    return source;
  }
  const isMobile = bowser.mobile;
  if (isMobile) {
    return source.mobile;
  }
  return source.desktop;
};

const defaultCaptions = {};

// @ts-ignore TS(2322): Type 'boolean' is not assignable to type 'string'.
function TourItem({
  src = '',
  type,
  // @ts-ignore TS(2322): Type 'boolean' is not assignable to type 'string'.
  footer = true,
  // @ts-ignore TS(2322): Type 'boolean' is not assignable to type 'React.ReactElement'.
  component = null,
  captions = defaultCaptions,
  bgScreen = '',
  className = '',
}) {
  const { title, subtitle } = captions;

  const renderBody = () => {
    switch (type) {
      case 'custom':
        return component;
      case 'video':
        return (
          <video
            loop
            muted
            autoPlay
            controls={false}
            preload="auto"
            src={getItemSource(src)}
            playsInline
          />
        );
      case 'image':
      default:
        return <img alt={title} src={getItemSource(src)} />;
    }
  };

  return (
    <div className={classnames('ws-tour__item', `ws-tour__item--${type}`, className)}>
      <div
        className="ws-tour__item-body"
        style={{
          background: bgScreen,
        }}
      >
        {renderBody()}
      </div>
      {footer && (
        <div className="ws-tour__item-footer">
          <div className="ws-tour__item-footer-title">{title}</div>
          <div className="ws-tour__item-footer-subtitle">{subtitle}</div>
        </div>
      )}
    </div>
  );
}

export default TourItem;
